import React from 'react';
import {MyDate} from "../dates/util";

export const name = "The Birthday Eve"
export const created_on = new MyDate(2019, 8, 9);
export const mod = () => {
    return (
        <>
            <p>
                Unlike what I promised last time, I don't think i'll be
                sharing any updates on my book read. Too much work. However,
                I would like to assure you that I did read that. I've read
                a few more since then. Check my goodread. I'm turning 25 in
                about 2 day. Yay! Taking into cognizance the modern day
                life expectancy, I'm through one-third of my life and boy
                I've had a decent run. Believe me, I'm pretty lucky to claim
                that I don't have a <em>whole lot of complaints</em> with how
                it has gone so far. I've a few, but those are the healthy ones;
                the ones that are required to drive my life. That balanced
                stress thingy.
            </p>
            <p>
                Waaaaait! I've a few more updates.
            </p>
            <p>
                I got promoted to SDE-2 in my firm. The promotion was regulation
                one, but I won't complain. It was interesting none-the-less.
            </p>
            <p>
                I splurged on a pair audio-technica bluetooth headphones. God,
                I'm so hooked to them. I rarely take'em off. They have significantly
                expanded my audio portfolio. Like, I've actively started using
                spotify. Ok, that has nothing to do with my headphones, but I
                don't mind attributing that behavior to my new headphones cuz
                the habbit just happened to co-incide. A bigger and better
                achievement has been that I've started listening
                to <a href="https://twitter.com/prabodh_agarwal/status/1156587594387525632"><span>podcasts</span></a>.
            </p>
            <p>
                I was recently introduced to the board-game of Catan. It is
                pretty amazing. I got to play the board game of friend's setup.
                I've also managed to get hooked to the mobile game. It just
                doesn't seem to get boring. So much is hinged on that roll
                of the dice. I think the rush-of-the-roll is what is addictive.
                Best part is that there is no literal roll on the app, but still,
                I think my brain just simulates that and stimulates the addiction
                centre.
            </p>
            <p>
                I've recently started coding actively on leetcode. I had this phase
                once in my third year, where I actively started coding on SPOJ,
                but that phase died away quickly. Recently my google foobar challenge
                re-opened, so I solved that and re-kindled the joy of algo coding. I
                would confess that I'm terrible at that, but I don't mind. I've convinced
                myself that it is good time utilization outside of work. Actually
                I've reduced my work to accomodate my leetcode'ng habbit. But I
                don't mind. Hope my manager neither. :-). Oh! btw! google foobar
                is real. I'm sure you would have come across secretive sounding
                pages that google foobar is a secret hiring weapon. Well, I can
                confirm that it is real. I actually have a referral code as well.
                Feel free to reach out to me over mail.
            </p>
            <p>
                Phew! That is a lot. And I didn't even come around to mention
                my birthday. Well I'll see what to do on birthday. I don't
                find the prospect of birthdays as exciting. I wanted to be home,
                but have a leave crunch so I'm in Hyderabad. I generally hate
                Sundays. Probably I won't hate my birthday Sunday as much.
                Hopefully I'll get to squeeze a game of squash and a burger.
                Been some time since I treated myself to a burger.
            </p>
        </>
    );
}
